import { render } from "./MyInactivePublications.vue.js?vue&type=template&id=71d977b2!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyInactivePublications.vue?vue&type=template&id=71d977b2"
import script from "./MyInactivePublications.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyInactivePublications.vue?vue&type=script&lang=js"
export * from "./MyInactivePublications.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyInactivePublications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/MyInactivePublications.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71d977b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71d977b2', __exports__)) {
    api.reload('71d977b2', __exports__)
  }
  
  module.hot.accept("./MyInactivePublications.vue.js?vue&type=template&id=71d977b2!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyInactivePublications.vue?vue&type=template&id=71d977b2", () => {
    api.rerender('71d977b2', render)
  })

}


export default __exports__